import { ButtonUtility } from "@components";
import { ThumbsDown, ThumbsUp } from "@untitledui/icons";
import { cx } from "@/utils/cx";

type InsightHelpfulFeedbackProps = {
	insightId: number;
	onVote: (insightId: number, helpful: boolean) => void;
	disabled?: boolean;
	selectedWasHelpful: boolean | null;
};

export const InsightHelpfulFeedback = ({
	insightId,
	selectedWasHelpful,
	onVote,
	disabled = false,
}: InsightHelpfulFeedbackProps) => (
	<div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
		<p className="font-medium text-quaternary text-sm">
			Esta sugestao foi util?
		</p>
		<div
			className={cx("flex items-center gap-1.5", disabled ? "opacity-70" : "")}
		>
			<div className="flex items-center gap-1">
				<span className="font-normal text-fg-secondary text-sm leading-[18px]">
					Sim
				</span>
				<ButtonUtility
					aria-pressed={selectedWasHelpful === true}
					className={cx(
						"size-4 p-0",
						selectedWasHelpful === true && "text-brand-secondary",
						!!disabled &&
							selectedWasHelpful === true &&
							"text-brand-secondary! opacity-70"
					)}
					color="tertiary"
					icon={<ThumbsUp className="size-4" strokeWidth={3} />}
					isDisabled={disabled}
					onClick={() => onVote(insightId, true)}
					size="sm"
					tooltip="Marcar sugestão como útil"
					type="button"
				/>
			</div>

			<div className="flex items-center gap-1">
				<span className="font-normal text-fg-secondary text-sm leading-[18px]">
					Não
				</span>
				<ButtonUtility
					aria-pressed={selectedWasHelpful === false}
					className={cx(
						"size-4 p-0",
						selectedWasHelpful === false && "text-fg-error-primary",
						!!disabled &&
							selectedWasHelpful === false &&
							"text-fg-error-primary! opacity-70"
					)}
					color="tertiary"
					icon={<ThumbsDown className="size-4" strokeWidth={3} />}
					isDisabled={disabled}
					onClick={() => onVote(insightId, false)}
					size="sm"
					tooltip="Marcar sugestão como não útil"
					type="button"
				/>
			</div>
		</div>
	</div>
);
